function toggleFoldOut(event) {
  var foldOutInfo = jQuery(event.currentTarget).closest(".case-item");
  if (jQuery(foldOutInfo).hasClass("expanded")) {
    var startHeight = jQuery(foldOutInfo).find(".case-text").height();
    var imagesHeight = jQuery(foldOutInfo).find(".case-images").height();
    jQuery(foldOutInfo)
      .find(".case-text")
      .css("height", startHeight + "px");
    jQuery(foldOutInfo)
      .find(".case-images")
      .css("height", imagesHeight + "px");

    setTimeout(function () {
      jQuery(foldOutInfo)
        .find(".case-text")
        .addClass("animating")
        .css("height", "0");
      jQuery(foldOutInfo)
        .find(".case-images")
        .addClass("animating")
        .css("height", "0");
      setTimeout(function () {
        jQuery(foldOutInfo).removeClass("expanded");
        jQuery(foldOutInfo).find(".arrow-down").removeClass("arrow-up");
        jQuery(foldOutInfo)
          .find(".case-text")
          .removeClass("animating")
          .removeAttr("style");
        jQuery(foldOutInfo)
          .find(".case-images")
          .removeClass("animating")
          .removeAttr("style");
      }, 500);
    });
    jQuery("html, body")
      .stop()
      .animate(
        {
          scrollTop: foldOutInfo.offset().top + -60,
        },
        500
      );
  } else {
    var desiredHeightText = jQuery(foldOutInfo)
      .find(".case-text .case-text-inner")
      .outerHeight();
    var desiredHeightImages = jQuery(foldOutInfo)
      .find(".case-images .case-images-inner")
      .outerHeight();
    jQuery(foldOutInfo)
      .find(".case-text")
      .addClass("animating")
      .css("height", desiredHeightText + "px");
    jQuery(foldOutInfo)
      .find(".case-images")
      .addClass("animating")
      .css("height", desiredHeightImages + "px");
    setTimeout(function () {
      jQuery(foldOutInfo).addClass("expanded");
      jQuery(foldOutInfo).find(".arrow-down").addClass("arrow-up");
      jQuery(foldOutInfo)
        .find(".case-text")
        .removeClass("animating")
        .removeAttr("style");
      jQuery(foldOutInfo)
        .find(".case-images")
        .removeClass("animating")
        .removeAttr("style");
    }, 500);
  }
}

var currentUrl = window.location.href;
var caseItem = currentUrl.split("#").pop();
var caseSection = document.getElementById("case-section");
var caseItemSelected = document.getElementById(caseItem);
if (caseItemSelected) {
  jQuery(caseItemSelected).addClass("expanded");
  jQuery(caseItemSelected).find(".arrow-down").addClass("arrow-up");
}

// jQuery("#contact-button").on("click", function (event) {
//   var target = jQuery("#contact");
//   // event.preventDefault();
//   jQuery("html, body")
//     .stop()
//     .animate(
//       {
//         scrollTop: target.offset().top - 100,
//       },
//       1000
//     );
// });

jQuery("p:has(button#contact-button)").css("text-align", "center");
